import React from 'react';
import '../../../components/jds/jds.css';
import '../clienteDados.css';
import { JdsButton } from '../../../components/jds/JdsButton';
import { CloseIcon } from '../../../components/jds/icons';

// Rótulo + valor em sentence case (no lugar de .tipo-campo/.campo).
export function Field({ label, children, error = false }) {
  return (
    <div className="cd-field">
      <div className="cd-field-label">{label}</div>
      <div
        className={`cd-field-value${error ? ' cd-field-value--error' : ''}`}
      >
        {children}
      </div>
    </div>
  );
}

export const InfoIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </svg>
);

export const AlertIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </svg>
);

// Modal de overlay fixo no visual JDS. `icon` é um nó opcional (ex.:
// <AlertIcon />); `actions` são os botões do rodapé.
export function ClienteModal({
  title,
  description,
  icon,
  children,
  actions,
  onClose,
  center = true,
  wide = false,
}) {
  return (
    <div className="jds-scope cd-modal-overlay">
      <div
        className={`cd-modal${center ? ' cd-modal--center' : ''}${
          wide ? ' cd-modal--wide' : ''
        }`}
        role="dialog"
        aria-modal="true"
        aria-label={typeof title === 'string' ? title : undefined}
      >
        {onClose && (
          <JdsButton
            className="cd-modal-close"
            variant="ghost"
            color="neutral"
            size="sm"
            iconOnly
            onClick={onClose}
            aria-label="Fechar"
          >
            <CloseIcon />
          </JdsButton>
        )}
        {icon && <div className="cd-modal-icon">{icon}</div>}
        <h2 className="jds-title-md">{title}</h2>
        {description && <p className="cd-modal-desc">{description}</p>}
        {children && <div className="cd-modal-body">{children}</div>}
        {actions && <div className="cd-modal-actions">{actions}</div>}
      </div>
    </div>
  );
}
